import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { getDateFormatForLang } from '@insolution/core-utils';
import { TranslateService } from '@ngx-translate/core';
import { format } from 'date-fns';

@Injectable({
  providedIn: 'root',
})
export class LocalDateFormatService {
  private translateService = inject(TranslateService);
  private currentLang = this.translateService.getCurrentLang();

  constructor() {
    this.translateService.onLangChange.pipe(takeUntilDestroyed()).subscribe((event) => (this.currentLang = event.lang));
  }

  private getFormat(): string {
    return getDateFormatForLang(this.currentLang);
  }

  public transform(value: string | undefined, showTime?: boolean): string {
    if (!value) return '';
    const date = new Date(value);
    if (isNaN(date.getTime())) return '';

    if (!showTime) {
      return format(date, this.getFormat());
    }

    return format(date, this.getFormat() + ', HH:mm');
  }
}
